import { Link } from 'found';
import React from 'react';

import { Box, SxProps, Theme } from '@mui/material';

import useScreenSize from '../../../../utils/useScreenSize';
import { borderRadius, boxShadows, cardDimensions, palette } from '../../../../assets/styles/themes/tokens';
import PlayIcon from './PlayIcon';
import { MuiCardBaseProps } from './MuiCardBase';

const MuiCardBaseCover: React.FC<{
  cover: string;
  isWide?: boolean;
  withPlayIcon?: boolean;
  itemLink: string;
  children?: React.ReactNode;
  isTruncated?: boolean;
}> = ({ cover, itemLink, isWide, withPlayIcon, children, isTruncated }) => {
  const { isSmallScreen } = useScreenSize();

  const wrapperSx = isSmallScreen ? 
    {
      width: isWide ? 176 : 94,
      minWidth: isWide ? 176 : 94,
      height: isTruncated ? '100%' : 130,
      position: 'relative',
    } : {
      borderRadius: borderRadius.sm,
      width: isWide ? 376 : 198,
      minWidth: isWide ? 376 : 198,
      height: '100%',
      position: 'relative',
      ':hover': {
        boxShadow: boxShadows.elevation26,
      },
    };

  return (
    <Link to={itemLink}>
      <Box sx={wrapperSx}>
        {withPlayIcon && <PlayIcon size={isSmallScreen ? 'small' : 'large'} />}
        <CoverImage
          cover={cover}
          data-testid={isSmallScreen ? 'mui-card-mobile__cover-image' : 'mui-card-desktop__cover-image'}
        />
        {children}
      </Box>
    </Link>

  );
};

export default MuiCardBaseCover;

export const CoverImage: React.FC<{
    cover: MuiCardBaseProps['cover'];
    className?: string;
    dataTestId?: string;
    customSx?: SxProps<Theme>;
  }> = ({ cover, className, dataTestId, customSx }) => {
    const { isSmallScreen } = useScreenSize();
    return <Box
      component='img'
      className={className}
      data-testid={dataTestId || 'cover-image'}
      src={cover}
      sx={{
        height: isSmallScreen ? cardDimensions.short.height : cardDimensions.long.height,
        width: '100%',
        borderRadius: borderRadius.sm,
        objectFit: 'cover',
        border: `${isSmallScreen ? '0.476px' : '1px'} solid ${palette.elevation.outlined}`,
        ':hover': {},
        ...customSx,
      }}
    />;
  };
